import { request } from "@/service/request";
import { HttpResponse } from "@/service/common/entity/HttpResponse";
import { ewodHost } from "@/config/host";
import { SupplierReportCapacityResponseDTO } from "../entity/SupplierReportCapacityResponseDTO";
import { SelectOption } from "../entity/SelectOption";
import { SupplierReportCapacityRequestDTO } from "../entity/SupplierReportCapacityRequestDTO";
import { SupplierCapacityPageRequestDTO } from "../entity/SupplierCapacityPageRequestDTO";
import { Results } from "../entity/Results";
/**
 * 获取上一个月产能提报信息
 * @returns
 */
export function getLastMonthCapacity(): Promise<
  HttpResponse<SupplierReportCapacityResponseDTO>
> {
  return request({
    url: `${ewodHost}/supplierReportCapacity/getLastMonthCapacity`,
    method: "get",
    silence: true,
  });
}

/**
 * 获取下一个月产能提报信息
 * @returns
 */
export function getNextMonthCapacity(): Promise<
  HttpResponse<SupplierReportCapacityResponseDTO>
> {
  return request({
    url: `${ewodHost}/supplierReportCapacity/getNextMonthCapacity`,
    method: "get",
    silence: true,
  });
}

/**
 * 获取服装产能支持面料类型枚举
 * @returns
 */
export function getSupplierReportCapacityFabric(): Promise<
  HttpResponse<SelectOption[]>
> {
  return request({
    url: `${ewodHost}/supplierReportCapacity/getSupplierReportCapacityFabric`,
    method: "get",
    withCredentials: true,
  });
}
/**
 * 新增供应商提报产能
 * @returns
 */
export function addSupplierReportCapacity(
  data: SupplierReportCapacityRequestDTO
): Promise<HttpResponse<void>> {
  return request({
    url: `${ewodHost}/supplierReportCapacity/addSupplierReportCapacity`,
    method: "post",
    data,
    withCredentials: true,
  });
}
/**
 * 获取供应商提报产能列表
 * @param data
 * @returns
 */
export function getSupplierReportCapacityList(
  data: SupplierCapacityPageRequestDTO
): Promise<HttpResponse<Results<SupplierReportCapacityResponseDTO>>> {
  return request({
    url: `${ewodHost}/supplierReportCapacity/getSupplierReportCapacityList`,
    method: "post",
    data,
    withCredentials: true,
  });
}

/**
 * 获取提报产能枚举值
 * @returns
 */
export function getSupplierReportCapacityStatus(): Promise<
  HttpResponse<SelectOption[]>
> {
  return request({
    url: `${ewodHost}/supplierReportCapacity/getSupplierReportCapacityStatus`,
    method: "get",
  });
}
